module.exports = __webpack_public_path__ + "img/google.5761cc79.png";